import React from 'react';
import { RiWhatsappLine } from 'react-icons/ri';

const WhatsAppButton = () => {
  const phoneNumber = '447902408574'; // Replace with your WhatsApp number

  return (
    <a
      href={`https://api.whatsapp.com/send?phone=${phoneNumber}`}
      className="bg-white text-blue-600 shadow-lg font-normal h-10 w-10 flex items-center justify-center rounded-full outline-none focus:outline-none mr-2"
      target="_blank"
      rel="noopener noreferrer"
    >
      <RiWhatsappLine />
    </a>
  );
};

export default WhatsAppButton;
